import { Extension } from '@tiptap/core'

export const GradientColor = Extension.create({
  name: 'gradientColor',

  addGlobalAttributes () {
    return [
      {
        types: ['textStyle'],
        attributes: {
          gradientColor: {
            default: null,
            parseHTML: element => {
              const bg = element.style?.backgroundImage || ''
              return bg && bg.includes('gradient') ? bg : null
            },
            renderHTML: attributes => {
              if (!attributes.gradientColor) {
                return {}
              }

              return {
                style: `background-image: ${attributes.gradientColor}; -webkit-background-clip: text; background-clip: text; color: transparent; -webkit-text-fill-color: transparent;`
              }
            }
          }
        }
      }
    ]
  },

  addCommands () {
    return {
      setGradientColor:
        color =>
          ({ chain }) =>
            chain()
              .setMark('textStyle', { gradientColor: color })
              .run(),

      unsetGradientColor:
        () =>
          ({ chain }) =>
            chain()
              .setMark('textStyle', { gradientColor: null })
              .removeEmptyTextStyle?.()
              .run()
    }
  }
})